module.exports = "https://static.energy5.com/_next/static/images/saveBigTime-bede153973636af3d4cf47102a16865f.png";